import {DictionaryItemApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";

/**
 * DictionaryItem model.
 */
export default class DictionaryItem {
	/**
	 * String using to search.
	 */
	public readonly searchString: string;

	constructor(public readonly id: string,
		public readonly name: string) {
		this.searchString = `${name}`.toLowerCase()
	}

	static fromJson(json: DictionaryItemApiDto): DictionaryItem {
		return new DictionaryItem(json.id, json.name);
	}

	toJson(): DictionaryItemApiDto {
		const json: DictionaryItemApiDto = {
			id: this.id,
			name: this.name
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({id = this.id, name = this.name}) {
		return new DictionaryItem(id, name);
	}
}